<template>
  <v-container class="white" grid-list-xl fluid ma-0 pa-0>
    <base-section
      id="map"
      space="0"
    >
      <iframe
        allowfullscreen
        aria-hidden="false"
        frameborder="1"
        height="350"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d208648.7257001975!2d-80.97991232780286!3d35.2030727849864!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88541fc4fc381a81%3A0x884650e6bf43d164!2sCharlotte%2C%20NC!5e0!3m2!1sen!2sus!4v1646226413605!5m2!1sen!2sus"
        style="border:0; display: block;"
        tabindex="0"
        width="100%"
      />
    </base-section>
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >
    <v-layout justify-center wrap >
      <v-flex xs12 md7><br>
        <v-layout wrap>
          <v-flex xs12 md6>
            <v-text-field ref="Json.FirstName" dense background-color="yellow lighten-5" :rules="[rules.required]" v-model="Json.FirstName" filled outlined  placeholder=" " label="FirstName"></v-text-field>
          </v-flex>
          <v-flex xs12 md6>
            <v-text-field ref="Json.LastName" dense background-color="yellow lighten-5" :rules="[rules.required]" v-model="Json.LastName" filled outlined   placeholder=" " label="LastName"></v-text-field>
          </v-flex>
          <v-flex xs12 md6>
            <v-text-field ref="Json.Email" dense background-color="yellow lighten-5" v-model="Json.Email" outlined :rules="emailRules" filled  placeholder=" " label="Email Id" type="email"></v-text-field>
          </v-flex>
          <v-flex xs12 md6>
            <v-text-field ref="Json.Mobile" dense background-color="yellow lighten-5" :rules="[rules.required]" v-model="Json.Mobile" outlined filled   placeholder=" " label="Mobile"></v-text-field>
          </v-flex>
          <v-flex xs12 md8>
            <v-textarea outlined ref="Json.Comments" filled dense background-color="yellow lighten-5" :rules="[rules.required]" v-model="Json.Comments" placeholder=" " full-width label="Message" counter></v-textarea>
          </v-flex>
          <v-card-actions>
            <v-btn text @click="$refs.form.reset()">Clear</v-btn>
            <v-btn :disabled="!valid" :loading="isLoading" class="white--text" color="primary" depressed @click=submit>Submit</v-btn>
          </v-card-actions>
        </v-layout><br><br>
      </v-flex>
      <v-flex xs12 md5>
        <v-card class="caption pa-0 elevation-0" style="max-width: 100%">
          <br><br>
           <v-card class="body-1 pa-0 elevation-0"> Contact Us</v-card><br>
          சார்லட் தமிழ்ச் சங்கம் <br><br>
          Email  : cltsangam@gmail.com<br>
          Address : P.O BOX 78131 CHARLOTTE, <br>
          NORTH CAROLINA 28277
        </v-card>
      </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
import ReportServices from '@/services/ReportServices'

  export default {
    provide: {
      heading: { align: 'center' },
    },
    data: () => ({
      valid: true,
      email: undefined,
      form: false,
      isLoading: false,
      password: undefined,
      phone: undefined,
      Json: {
        _id: '',
        FirstName: '',
        LastName: '',
        Email: '',
        Mobile: '',
        Comments: ''
      },
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      rules: {
        length: len => v => (v || '').length >= len || `Invalid character length, required ${len}`,
        password: v => (v || '').match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*(_|[^\w])).+$/) || 'Password must contain an upper case letter, a numeric character, and a special character',
        required: v => !!v || 'This field is required',
      },
    }),
  methods: {
    async cleardata () {
        this.Json.FirstName = ''
        this.Json.LastName = ''
        this.Json.Email = ''
        this.Json.Mobile = ''
        this.Json.Comments = ''
    },
    async submit () {
      if (this.$refs.form.validate()) {
        ReportServices.submitToContactUs(this.Json)
        setTimeout(() => {
          this.$router.push('/ThankYou')
        }, 500)
      }
    }
  },
  async mounted () {
    this.loading = false
  }
}
</script>